import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
//slices
import { companySelector } from 'slices/company';
import { userSelector } from 'slices/user';

const LogoComponent = ({ secondaryImage, isDesktop, isScroll = false, isSticky }) => {
  const { benefitedBookstore } = useSelector(userSelector);
  const { logo } = useSelector(companySelector);

  const getLogoImage = () => (
    !secondaryImage ? (
      <Link className={`${isDesktop ? isScroll ? `show-desktop-scroll ${isSticky ? 'd-block' : 'd-none'}` : 'show-desktop w-100' : 'show-mobile d-lg-none w-100'}`} to="/">
        <img className={`${isDesktop ? isScroll ? 'd-none d-lg-block logo--scroll' : 'logo--desktop' : 'logo--mobile'}`} alt="Logotipo Empresa" src={logo} />
      </Link>
    ) : (
      <>
        <Link className={`${isDesktop ? isScroll ? `show-desktop-scroll mx-0 p-0 ${isSticky ? 'd-block' : 'd-none'}` : 'show-desktop' : 'show-mobile d-lg-none mx-2'}`} to="/">
          <img className={`${isDesktop ? isScroll ? 'd-none d-lg-block logo--scroll p-0' : 'logo--desktop' : 'logo--mobile'}`} alt="Logotipo Empresa" src={logo} />
        </Link>
        <Link className={`${isDesktop ? isScroll ? `show-desktop-scroll mx-0 p-0 ms-2 ${isSticky ? 'd-block' : 'd-none'}` : 'show-desktop__secondary' : 'show-mobile__secondary d-lg-none'}`} to="/">
          <img
            className={`${isDesktop ? isScroll ? 'd-none d-lg-block logo--scroll separator-logo position-relative' : 'logo--desktop separator-logo' : 'logo--mobile separator-logo'}`}
            alt="E.Asociada"
            src={benefitedBookstore ? benefitedBookstore?.url : ''}
          />
        </Link>
      </>
    )
  )

  return (
    <>
      {isScroll ? getLogoImage() :
        <Col 
          md={!secondaryImage ? 2 : 3} 
          className={`${isDesktop ? !secondaryImage ? 'd-none d-lg-block' : ' d-none d-lg-flex gap-2' : 'd-flex justify-content-center'}`}
        >
          {getLogoImage()}
        </Col>}
    </>
  );
};

LogoComponent.propTypes = {
  isDesktop: PropTypes.bool,
  isScroll: PropTypes.bool,
  isSticky: PropTypes.bool,
  secondaryImage: PropTypes.bool
};

export default LogoComponent;
